// extracted by mini-css-extract-plugin
export var details = "_k5-0";
export var inspectorPopover = "_k5-1";